import React from 'react'
import { Select } from '@mantine/core'

import { ScriptExhibitDesignation } from '@/types'

type ExhibitDesignationSelectProps = {
  value: ScriptExhibitDesignation
  onChange: (value: ScriptExhibitDesignation) => void
}

const DESIGNATION_OPTIONS: {
  value: ScriptExhibitDesignation
  label: string
}[] = [
  { value: 'plaintiff', label: 'Plaintiff' },
  { value: 'defendant', label: 'Defendant' },
  { value: 'unknown', label: 'Unknown' },
]

// Kept on its own so it can be swapped for an attendee picker without touching
// the exhibit rows (the product decision on who sets the designation is open).
export const ExhibitDesignationSelect: React.FC<
  ExhibitDesignationSelectProps
> = ({ value, onChange }) => (
  <Select
    label="Designation"
    placeholder="Select option"
    data={DESIGNATION_OPTIONS}
    // A row always has a designation; "Unknown" is the way to say it is not known.
    allowDeselect={false}
    value={value}
    onChange={designation => onChange(designation as ScriptExhibitDesignation)}
    sx={{ flex: '1 1 0', minWidth: 0 }}
  />
)
